import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/motion/Reveal";

export const TestDriveCTA = ({ vehicle }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["12%", "-8%"]);

  return (
    <section ref={ref} data-testid="test-drive-cta" className="relative overflow-hidden bg-crimson text-obsidian">
      {vehicle && (
        <motion.img style={{ x }} src={vehicle.hero_image} alt="" aria-hidden className="pointer-events-none absolute -right-[5%] top-1/2 w-[70%] -translate-y-1/2 opacity-[0.16] mix-blend-multiply lg:w-[55%]" />
      )}
      <div className="wrap relative grid gap-10 py-24 sm:py-32 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-8">
          <Reveal y={12}><p className="font-mono text-[11px] uppercase tracking-[0.22em] text-obsidian/70 sm:text-xs">04 — Test Drive</p></Reveal>
          <MaskedLines as="h2" inView lines={["Feel it before", "you decide."]} className="display-xl mt-6 text-obsidian" lineClassName={(i) => (i === 1 ? "font-editorial italic font-normal normal-case tracking-normal" : "")} />
          <Reveal delay={0.3} className="mt-8 max-w-lg">
            <p className="text-base leading-relaxed text-obsidian/80 sm:text-lg">Pick a model, pick a day. We will have the keys ready on West Canal Road — no obligation, no pressure, just the drive.</p>
          </Reveal>
        </div>
        <Reveal delay={0.4} className="lg:col-span-4 lg:justify-self-end">
          <Link to="/test-drive" data-testid="cta-test-drive-button" className="btn-dark !px-8 !py-5 !text-sm">
            Book a Test Drive <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
